import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Executed = ({
  size,
  type,
  theme,
  className,
  dataTestId = "executed",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M10.988 7.362a.667.667 0 0 0-.958-.927L7.234 9.327l-1.2-1.655a.667.667 0 1 0-1.079.783l1.666 2.298a.667.667 0 0 0 1.019.072l3.348-3.463Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.156.222c-.737 0-1.334.597-1.334 1.333v12.89c0 .736.597 1.333 1.334 1.333h9.692c.737 0 1.334-.597 1.334-1.333v-9.56c0-.354-.14-.693-.39-.943l-3.33-3.33c-.25-.25-.59-.39-.944-.39H3.156Zm0 1.333h6.362l3.33 3.33v9.56H3.156V1.555Z"
    />
  </SVGIcon>
);
